// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import moment from 'moment';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminSponsorListItem extends Base {
  constructor(props, context) {
    super(props);
  }

  _goToItemShow(sponsorId) {
    this.props.history.push(`/admin/sponsors/${sponsorId}`);
  }

  render() {
    const { sponsor } = this.props;
    return (
      <tr className="linkable" onClick={this._goToItemShow.bind(this, sponsor._id)}>
        <td style={{width: '64px'}}><img src={sponsor.logo ? sponsor.logo : "/img/yt_logo.png"} /></td>
        <td>{sponsor.name}</td>
        <td className="_30">{moment(sponsor.updated).format("MMMM Do YYYY, h:mm a")}</td>
      </tr>
    )
  }
}

AdminSponsorListItem.propTypes = {
  sponsor: PropTypes.object.isRequired
}

export default withRouter(AdminSponsorListItem);



// WEBPACK FOOTER //
// modules/sponsor/components/AdminSponsorListItem.js.jsx